// extracted by mini-css-extract-plugin
export default {"loader":"Spinner_loader__P8drB","spin":"Spinner_spin__8rKTE","container":"Spinner_container__BYOkl"};